import { Deal } from '@ca/common/types'
import Page from '@shell/Page'
import useBundleType from '@order/hooks/useBundleType'
import { useDealSelect } from '@order/hooks/useDealTypeModal'
import IntroDeals from '@screens/intro/deals'
import { router } from 'expo-router'
import useSession from 'hooks/useSession'

export default function DealSelect() {
  const pendingOrder = useSession((s) => s.pendingOrder) // mockPendingOrder

  const { bundleType } = useBundleType()

  const { selectDeal } = useDealSelect()

  const isExtra = bundleType === 'extra'

  const onSelectDeal = (deal: Deal) => {
    selectDeal({
      deal,
      bundle: bundleType,
      onSelected: () =>
        router.push({
          pathname: '/frame/select',
          params: { bundleType },
        }),
    })
  }

  return (
    <Page
      stage="deal"
      back={false}
      validateStaff
      dropdown={!pendingOrder ? 'configDeals' : undefined}
    >
      <IntroDeals onSelect={onSelectDeal} hideBrand={isExtra} />
    </Page>
  )
}
